module.exports = function() {
  return new Worker(__webpack_public_path__ + "d24838d9c23319b138d0.worker.js");
};